// Shared helpers for the registration/* Stimulus controllers. These controllers
// jointly replace the legacy app/javascript/registration.js jQuery script and
// communicate via bubbling CustomEvents dispatched on the shared <form>.

export function readFormParams(el) {
  const form = el.closest("form")
  if (!form || !form.dataset.regFormParams) return {}
  return JSON.parse(form.dataset.regFormParams)
}

export function dataJSON(el, camelCaseName) {
  const raw = el?.dataset?.[camelCaseName]
  if (!raw) return undefined
  try {
    return JSON.parse(raw)
  } catch {
    return undefined
  }
}

export function isVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
}

export function nextLabelSpan(el) {
  let sibling = el.nextElementSibling
  while (sibling && sibling.tagName !== "LABEL") sibling = sibling.nextElementSibling
  return sibling ? sibling.querySelector("span") : null
}

export function prevSpan(el) {
  const sibling = el.previousElementSibling
  return sibling && sibling.tagName === "SPAN" ? sibling : null
}

export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

export function buildPriceFormatting(params) {
  const czkStr = params.locale === "en" ? "CZK" : "Kč"
  const eurStr = params.locale === "en" ? "approx." : "cca."
  let priceStr
  let priceRate = null

  if (params.currency === "EUR") {
    priceStr = "X EUR"
  } else if (params.show_in_eur) {
    priceStr = `X ${czkStr} <span class="price-val-eur">(${eurStr} Y EUR)</span>`
    priceRate = params.currency_rate
  } else {
    priceStr = `X ${czkStr}`
  }

  return { priceStr, priceTotalStr: priceStr, priceRate, locale: params.locale }
}

export function formattedValue(value, locale) {
  const count = value % 1 === 0 ? 0 : 2
  return value.toLocaleString(locale, { minimumFractionDigits: count, maximumFractionDigits: count })
}

export function convertedValue(value, priceRate, locale) {
  return priceRate ? formattedValue(value / priceRate, locale) : ""
}

export function renderPrice(fmt, value) {
  return fmt.priceStr.replace("X", formattedValue(value, fmt.locale)).replace("Y", convertedValue(value, fmt.priceRate, fmt.locale))
}

export function renderTotalPrice(fmt, value) {
  return fmt.priceTotalStr.replace("X", formattedValue(value, fmt.locale)).replace("Y", convertedValue(value, fmt.priceRate, fmt.locale))
}
